import {DialogController} from 'aurelia-dialog';
import { I18N } from 'aurelia-i18n';
  
export class CancelAutopayDialog {
	static inject = [DialogController, I18N];
	header: string;
	subheader: string;

	constructor(public controller, private i18n) { }

	activate() {
		this.header = this.i18n.i18next.t('cancelAutopay', 'Cancel Autopay');
		this.subheader = this.i18n.i18next.t('confirmCancelAutopay', 'You are about to cancel this autopay plan, do you wish to continue?');
	}
}
